import { FETCH_CLIENTS, RATING_DATA_FETCHED,DASHBOARD_TOP_ISSUE, GETING_DATA_BY_LOCALSTORAGE, SUMMARY_FETCHED, REPORT_DOWNLOAD, MAIN_SCREEN_SUMMARY_FETCHED, DASHBOARD_SUMMARY_FETCHED, VENDOR_SUMMARY_FETCHED } from "../actions";
const initialState = {
  clients: [],
  response: null,
  localClient: null,
  summary: null,
  mainSummary:null,
  reportDownload: false,
  totalClient:[],
  dashboardSummary: [],
  vendorSummary: [],
  topissue:[],
  ratingData:[],
  loading: true
};

const summary = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CLIENTS:
      return {
        ...state,
        clients: action.clients,
        response: action.response,
        totalClient:action.res
      };
    case GETING_DATA_BY_LOCALSTORAGE:
      return {
        ...state,
        localClient: action.localClient,
      };
    case SUMMARY_FETCHED:
      return {
        ...state,
        summary: action.payload
      };
    case MAIN_SCREEN_SUMMARY_FETCHED:
      return {
        ...state,
        mainSummary: action.payload
      };
    case REPORT_DOWNLOAD:
      return {
        ...state,
        reportDownload: action.payload
      }
    case DASHBOARD_SUMMARY_FETCHED:
      return {
        ...state,
        dashboardSummary: action.payload,
        loading: action.payload ? false : true
      }
    case VENDOR_SUMMARY_FETCHED:
      return {
        ...state,
        vendorSummary: action.payload,
        loading: action.payload ? false : true
      }
      case DASHBOARD_TOP_ISSUE:
        return {
          ...state,
          topissue: action.payload,
          loading: action.payload ? false : true
        }
        case RATING_DATA_FETCHED:
          return {
            ...state,
            ratingData: action.payload,
            loading: action.payload ? false : true
          }
    default:
      return state;
  }
};

export default summary;
